"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const httpRepository_1 = __importDefault(require("./httpRepository"));
const CodingRepository = {
    DEFAULT_PROVIDER_MAPPING: {
        coding1: '',
        coding2: '',
        coding3: '',
        coding4: '',
        coding5: '',
        coding6: '',
        coding7: '',
        coding8: '',
    },
    getCodingLists: async ({ skipDisabled }) => {
        const response = await httpRepository_1.default.tradeshiftGo().get(`/rest/coding/lists?includeDisabled=${skipDisabled ? 'false' : 'true'}`);
        return response.data;
    },
    saveCodingList: async ({ codingList }) => {
        const response = await httpRepository_1.default.tradeshiftGo().post('/rest/coding/lists/', {
            code: codingList.code,
            description: codingList.description,
            group: codingList.group,
            id: codingList.id,
            name: codingList.name,
            ordering: codingList.ordering,
            target: codingList.target,
        });
        return response.data;
    },
    deleteCodingList: async ({ selectedCodingList }) => {
        const response = await httpRepository_1.default.tradeshiftGo().delete(`/rest/coding/lists/${selectedCodingList.code}`);
        return response.data;
    },
    getCodingListEntries: async ({ codingListCode }) => {
        const response = await httpRepository_1.default.tradeshiftGo().get(`/rest/coding/lists/${codingListCode}/entries`);
        return response.data;
    },
    getInactiveCodingListEntries: async ({ companyId }) => {
        if (companyId) {
            const response = await httpRepository_1.default.tradeshiftGo().get(`/rest/company/${companyId}/coding/lists/inactiveEntries`);
            return response.data;
        }
        else {
            return {};
        }
    },
    deleteCodingListEntry: async ({ codingListCode, codingEntryId, }) => {
        const response = await httpRepository_1.default.tradeshiftGo().delete(`/rest/coding/lists/${codingListCode}/entries/${codingEntryId}`);
        return response.data;
    },
    saveCodingListEntry: async ({ codingListCode, codingEntryId, codingEntryLabel, }) => {
        const response = await httpRepository_1.default.tradeshiftGo().put(`/rest/coding/lists/${codingListCode}/entries/${codingEntryId}`, {
            entryLabel: codingEntryLabel,
        });
        return response.data;
    },
    changeCodingListEntryId: async ({ codingListCode, codingEntryId, newCodingEntryId, codingEntryLabel, }) => {
        const response = await httpRepository_1.default.tradeshiftGo().put(`/rest/coding/lists/${codingListCode}/entries/${newCodingEntryId}?replaceEntryId=${codingEntryId}`, {
            entryLabel: codingEntryLabel,
        });
        return response.data;
    },
    enableCodingList: async ({ codingListCode }) => {
        const response = await httpRepository_1.default.tradeshiftGo().post(`/rest/coding/lists/${codingListCode}/enable`);
        return response.data;
    },
    disableCodingList: async ({ codingListCode }) => {
        const response = await httpRepository_1.default.tradeshiftGo().post(`/rest/coding/lists/${codingListCode}/disable`);
        return response.data;
    },
    toggleCodingListEntry: async ({ codingListCode, codingEntryId, teamId, state, }) => {
        const response = await httpRepository_1.default.tradeshiftGo().put(`/rest/teams/${teamId}/coding/lists/${codingListCode}/entries/${codingEntryId}/state`, {
            entryId: codingEntryId,
            value: state,
        });
        return response.data;
    },
    deleteProviderMapping: async () => {
        const response = await httpRepository_1.default.tradeshiftGo().delete('/rest/configuration/ProviderApiMap');
        return response.data;
    },
    setProviderMapping: async (value) => {
        const response = await httpRepository_1.default.tradeshiftGo().post('/rest/configuration/ProviderApiMap', { value });
        return response.data;
    },
    getProviderMapping: async () => {
        const response = await httpRepository_1.default.tradeshiftGo().get('/rest/configuration/ProviderApiMap');
        return response.data;
    },
    getProviderFields: async () => {
        const response = await httpRepository_1.default.tradeshiftGo().get('/rest/coding/providerFields');
        return response.data;
    },
    saveProviderFields: async ({ providerFields }) => {
        const response = await httpRepository_1.default.tradeshiftGo().put('/rest/coding/providerFields', providerFields);
        return response.data;
    },
    getTeamCodingListEntries: async ({ teamId, listId }) => {
        const response = await httpRepository_1.default.tradeshiftGo().get(`/rest/teams/${teamId}/coding/lists/${listId}/entries`);
        return response.data;
    },
    setCodingEntryState: async ({ entryId, entryState, listId, teamId, }) => {
        const response = await httpRepository_1.default.tradeshiftGo().put(`/rest/teams/${teamId}/coding/lists/${listId}/entries/${entryId}/state`, entryState);
        if (response.status === 204) {
            return {};
        }
        else if (response.status >= 200 && response.status < 300) {
            return response.data;
        }
        else {
            throw new Error('An error occurred while setting the coding entry state.');
        }
    },
};
exports.default = CodingRepository;
